import api from "../services/authService";

/**
 * The intake file — intakes shown as early matters (whgdocs-intake-files-design.md).
 *
 * The server owns the visibility rule (signed = gone; live = shows; closed
 * fades after 60 days; stale-live after 90); these calls only ask and render.
 */

const raise = (error, fallback) => {
  const message =
    error.response?.data?.error || error.response?.data?.message || fallback;
  const failure = new Error(message);
  failure.status = error.response?.status || 500;
  throw failure;
};

export const searchIntakesAPI = async (term, { includeClosed = false, limit = 25 } = {}) => {
  try {
    const params = new URLSearchParams({ search: term || "", limit: String(limit) });
    if (includeClosed) params.set("include_closed", "1");
    return await api.get(`/intakes/?${params.toString()}`);
  } catch (error) {
    return raise(error, "Failed to search intakes");
  }
};

export const fetchIntakeAPI = async (intakeId) => {
  try {
    return await api.get(`/intakes/${encodeURIComponent(intakeId)}/`);
  } catch (error) {
    return raise(error, "Failed to load the intake");
  }
};

export const fetchIntakeDocumentsAPI = async (intakeId) => {
  try {
    return await api.get(`/intakes/${encodeURIComponent(intakeId)}/documents/`);
  } catch (error) {
    return raise(error, "Failed to load the intake's documents");
  }
};
